import { Grid, List, ListItem, ListItemText } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment';
import { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { ThemedSecondaryBtn } from '@themes/defaultThemeProps';
import { makeStyles } from '@mui/styles';

const LogDetails = ({ open, handleClose, data }) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flex: '0.2',
      minWidth: '200px',
    },
    margin: {
      margin: theme.spacing(1),
    },
    listLabel: {
      flex: '0.2',
      minWidth: '150px',
      align: 'left',
      fontSize: '16px',
      fontWeight: 700,
    },
    maskedInput: {
      minHeight: '50px',
      paddingLeft: '10px',
    },
    listData: {
      flex: '0.2',
      minWidth: '400px',
      align: 'left',
    },
    referenceListItem: {
      flex: '0.2',
      minWidth: '600px',
      align: 'left',
      paddingLeft: '150px',
    },
    grid: {
      height: '40vh',
      padding: '10px',
      paddingRight: '80px',
      paddingLeft: '40px',
    },
    buttonbar: {
      '& > *': {
        margin: theme.spacing(1),
        float: 'right',
      },
    },
  }));

  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    (<Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
      maxWidth='lg'
    >
      <DialogTitle id='form-dialog-title'>Log Information</DialogTitle>
      <DialogContent>
        <Grid
          container
          justifyContent='space-around'
          spacing={1}
          className={classes.grid}
        >
          <Grid item xs={1} />
          <Grid item xs={11}>
            <List aria-label='device summary'>
              <ListItem alignItems='flex-start'>
                <ListItemText
                  className={classes.listLabel}
                  primary='Date/Time:'
                  disableTypography
                />
                <ListItemText
                  className={classes.listData}
                  primary={moment(data?.created_at)
                    .format('LLL')
                    .toLocaleString()}
                />
              </ListItem>
              <ListItem alignItems='flex-start'>
                <ListItemText
                  className={classes.listLabel}
                  primary='Log Level:'
                  disableTypography
                />
                <ListItemText
                  className={classes.listData}
                  primary={data?.level}
                />
              </ListItem>
              {data?.user_id ? (
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='User Id:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={data?.user_id}
                  />
                </ListItem>
              ) : null}
              {data?.session_id ? (
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Session Id:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={data?.session_id}
                  />
                </ListItem>
              ) : null}
              {data?.scopes ? (
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Scopes:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={data?.scopes.join(',')}
                  />
                </ListItem>
              ) : null}
              <ListItem alignItems='flex-start'>
                <ListItemText
                  className={classes.listLabel}
                  primary='Message:'
                  disableTypography
                />
                <ListItemText
                  className={classes.listData}
                  primary={data?.message?.message}
                />
              </ListItem>
            </List>

            {data?.message?.meta_data ? (
              <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1bh-content'
                  id='panel1bh-header'
                >
                  <Typography className={classes.listLabel}>
                    Metadata
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.listData}>
                    {data?.message?.meta_data}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ) : null}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ThemedSecondaryBtn onClick={handleClose}>Close</ThemedSecondaryBtn>
      </DialogActions>
    </Dialog>)
  );
};

export default LogDetails;
